import { previewFeedbackMessageButton } from "./litigationCaseDetailsSpecialActions";
import {
  STAGE_ADMINISTRATIVE_PROCEEDINGS,
  STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT,
} from "../../Stages/StagesAdministrativeLaw";
import { CivilServiceLaw } from "../../../types/Products/AdministrativeLaw/CivilServiceLaw/CivilServiceLaw";

export const civilServiceLawDetailsSpecialActions = (product: CivilServiceLaw) => {
  let specialActions = [];

  if (product.stage === STAGE_ADMINISTRATIVE_PROCEEDINGS) {
    specialActions.push(previewFeedbackMessageButton(product, "message/administrativeLaw/feedback"));
  }

  if (product.stage === STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT) {
    specialActions.push(previewFeedbackMessageButton(product));
  }

  if (specialActions.length === 0) {
    return null;
  }

  return specialActions;
};
